"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEditText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputEditText = styled_components_1.default.input `
  width: auto;

  ::placeholder {
    color: #ccc;
  }
`;
//# sourceMappingURL=input-edit-text.js.map